import {connect} from '@gisatcz/ptr-state';

import Action from '../../../../state/Action';
import Select from '../../../../state/Select';

import presentation from './presentation';

const mapStateToProps = (state, ownProps) => {
	return {
		styles: Select.styles.getAllAsObject(state),
		availableStyleKeys: Select.app.getLocalConfiguration(
			state,
			`data.layerStyles.${ownProps.layerKey}.available`
		),
		activeStyleKey: Select.app.getLocalConfiguration(
			state,
			`data.layerStyles.${ownProps.layerKey}.active`
		),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		handleLayer: styleKey => {
			dispatch(
				Action.insar.handleMapLayer(
					ownProps.mapKey,
					ownProps.layerKey,
					styleKey
				)
			);
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
